let globalT: ((key: string) => string) | null = null;

const setGlobalT = (t: (key: string) => string) => {
  globalT = t;
};

const getGlobalT = () => {
  if (!globalT) {
    return null;
  }
  return globalT;
};

export default {
  setGlobalT,
  getGlobalT,
};
